import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import styled, { css } from 'styled-components';
import { color } from '../../../styles/styles.js';
var StyledCard = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: ", ";\n  background-color: ", ";\n\n  color: ", ";\n  border: solid 1px ", ";\n  box-sizing: border-box;\n  ", "\n"], ["\n  border-radius: ", ";\n  background-color: ", ";\n\n  color: ", ";\n  border: solid 1px ", ";\n  box-sizing: border-box;\n  ", "\n"])), function (props) {
  return props.borderRadius;
}, function (props) {
  return props.theme === 'dark' ? color.darkModeDarker : color.lightest;
}, function (props) {
  return props.theme === 'dark' ? color.medium : 'inherit';
}, function (props) {
  return props.theme === 'dark' ? color.darkModeMedium : color.border;
}, function (props) {
  return props.boxShadow && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);\n    "], ["\n      box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);\n    "])));
});
var templateObject_1, templateObject_2;
export { StyledCard };